(function(d,w) {
  var container = document.querySelector('.header-links');
  if (!container) return;

  var megaMenus = container.querySelectorAll('[data-has-mega-menu]');
  if (megaMenus.length === 0) return;

  let usingTouchEvents;
  let previoustMegaMenu = null;
  let currentMegaMenu = null;
  let allowMainLinkTouch = false;
  let hasLoadedItems;

  let timeoutId;
  let delay = 500;
  
  // Async the items for the mega menus
  const addItems = async () => {
    var fetchItems = await fetch (w.Shopify.routes.root + "?section_id=async-mega-menu-items")
      .then(res => res.text())
      .then(text => {
        var markup = new DOMParser().parseFromString(text, "text/html");
        var content = markup.querySelector('.async-mega-menu-items');

        return content;
      });;

    if (!fetchItems) return;
    
    d.querySelector('.header-links').querySelectorAll('[data-mega-menu-items]').forEach(div => {
      var handle = div.dataset.megaMenuItems;
      if (!handle) return;

      fetchItems.querySelectorAll('[data-async-mega-menu-items]').forEach(items => {
        if (items.dataset.asyncMegaMenuItems === handle) {
          div.innerHTML = items.innerHTML;
        }
      });
    })
  }

  // Open or close one panel: the class shows it (header.css), inert keeps a closed panel's links out of the Tab order
  // (snippets/mega-menu.liquid renders it closed) and aria-expanded tells the state on the chevron button beside the
  // parent link (sections/header.liquid). Focus left in a panel that closes goes back to that button, not to the page top.
  const setMegaMenuOpen = (menu, open) => {
    if (!menu) return;

    menu.classList.toggle('has-active-menu', open);

    var frame = menu.querySelector('.mega-menu-frame');
    var toggle = menu.querySelector('.mega-menu-toggle');

    if (frame) {
      if (!open && toggle && frame.contains(d.activeElement)) toggle.focus();
      frame.toggleAttribute('inert', !open);
    }

    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  var delayedMegaMenuOpen;
  var delayedMegaMenuClose;
  var activeMegaMenu;
  var hasUsedTouch;
  var preventMainLink = true;
  var getAsyncItems = true;
  var hasLeftBeforeDelay = false;

  const openingMegaMenu = (e) => {
    var trigger = e.detail.trigger;
    if (!activeMegaMenu) activeMegaMenu = trigger;
    
    var triggerIsActive = trigger === activeMegaMenu;

    if (getAsyncItems) {
      addItems();
      getAsyncItems = false;
    }

    if (delayedMegaMenuOpen) {
      clearTimeout(delayedMegaMenuOpen);
    }
    
    // A panel the keyboard opened has had no mouseleave, so no pending close: the pointer arriving on another item
    // switches to it at once, as moving from one hovered item to the next does (2026-11-01).
    if (!triggerIsActive && !delayedMegaMenuClose && activeMegaMenu.classList.contains('has-active-menu')) {
      setMegaMenuOpen(activeMegaMenu, false);
      setMegaMenuOpen(trigger, true);
      activeMegaMenu = trigger;
      return;
    }

    if (delayedMegaMenuClose) {
      clearTimeout(delayedMegaMenuClose);

      if (!triggerIsActive) {
        setMegaMenuOpen(activeMegaMenu, false);
        setMegaMenuOpen(trigger, true);
        
        activeMegaMenu = trigger;
        
        return;
      }
    }

    delayedMegaMenuOpen = setTimeout(() => {
      if (!hasLeftBeforeDelay) {
        setMegaMenuOpen(activeMegaMenu, true);
      }
    }, delay);
    
    hasLeftBeforeDelay = false;
  };
  
  const closingMegaMenu = () => {
    delayedMegaMenuClose = setTimeout(() => {
      setMegaMenuOpen(activeMegaMenu, false);
      
      activeMegaMenu = false;
    }, delay);
  };
  
  const openingMegaMenuTouch = (e) => {
    var trigger = e.detail.trigger;
    
    if (!hasUsedTouch) hasUsedTouch = true;
    
    if (getAsyncItems) {
      addItems();
      getAsyncItems = false;
    }

    var closestTrigger = e.target.classList.contains('has-active-menu') || e.target.closest('.has-active-menu');

    if (!preventMainLink && trigger !== activeMegaMenu) {
      preventMainLink = true;
    }
    
    if (trigger === activeMegaMenu) {
      if (preventMainLink) {
        preventMainLink = false;
        return;
      }
    }

    if (activeMegaMenu && trigger !== activeMegaMenu) {
      setMegaMenuOpen(activeMegaMenu, false);
    }
    
    setMegaMenuOpen(trigger, true);
    
    activeMegaMenu = trigger;
  };

  // A click from the keyboard (Enter on a link: detail 0) is never held back, even after an earlier touch (2026-11-01).
  const openingMegaMenuClick = (e) => {
    if (preventMainLink && hasUsedTouch && e.detail !== 0) {
      e.preventDefault();
    }
  }

  const leftBeforeDelay = (e) => {
    if (delayedMegaMenuOpen) {
      hasLeftBeforeDelay = true;
    }
  }

  // Event bus
  container.addEventListener('mega-menu:enter', openingMegaMenu);
  container.addEventListener('mega-menu:leave', closingMegaMenu);
  container.addEventListener('mega-menu:left-before-delay', leftBeforeDelay);
  container.addEventListener('mega-menu:touch', openingMegaMenuTouch);
  container.addEventListener('mega-menu:click', openingMegaMenuClick);

  // Used to send mega menu events
  const megaMenuEvent = (eventType, trigger) => {
    container.dispatchEvent(new CustomEvent ("mega-menu:" + eventType, {
      bubbles: true,
      detail: { 
        trigger: trigger,
      }
    }));
  }
  
  // Bind event types to mega menu links
  megaMenus.forEach(menu => {
    menu.addEventListener("mouseenter", () => megaMenuEvent('enter', menu));
    menu.addEventListener("mouseleave", () => megaMenuEvent('leave', menu));
    menu.addEventListener("mouseleave", () => megaMenuEvent('left-before-delay', menu));
    // A tap on the chevron button is its own click (below), not the first tap of the parent link; it still counts as
    // touch, so a tap outside closes the panel it opened.
    menu.addEventListener("touchstart", (e) => {
      if (e.target.closest('.mega-menu-toggle')) hasUsedTouch = true;
      else megaMenuEvent('touch', menu);
    }, {
      capture: true, 
      passive: true,
    });
    menu.addEventListener("click", openingMegaMenuClick);
  });

  // The chevron button (disclosure navigation, 2026-11-02): a click opens or closes its panel at once, without the hover
  // delay. Keyboard and screen readers press it as a click (Enter or Space), so they open the panel as a mouse does
  // by resting on it; the parent link beside it is a plain link. ArrowDown on either opens and moves into the first
  // link. Esc in the item closes it and puts focus on the button. Tab out of the item closes it, so an open panel never
  // covers the page while focus is elsewhere.
  const openMegaMenuNow = (menu) => {
    clearTimeout(delayedMegaMenuOpen);
    clearTimeout(delayedMegaMenuClose);
    hasLeftBeforeDelay = false;

    if (getAsyncItems) {
      addItems();
      getAsyncItems = false;
    }

    if (activeMegaMenu && activeMegaMenu !== menu) setMegaMenuOpen(activeMegaMenu, false);

    setMegaMenuOpen(menu, true);
    activeMegaMenu = menu;
  };

  const closeMegaMenuNow = (menu) => {
    clearTimeout(delayedMegaMenuOpen);
    clearTimeout(delayedMegaMenuClose);

    setMegaMenuOpen(menu, false);
    if (activeMegaMenu === menu) activeMegaMenu = false;
  };

  megaMenus.forEach(menu => {
    var link = menu.querySelector('.mega-menu-main-link');
    var toggle = menu.querySelector('.mega-menu-toggle');
    var frame = menu.querySelector('.mega-menu-frame');
    if (!link || !toggle || !frame) return;

    toggle.addEventListener('click', () => {
      if (menu.classList.contains('has-active-menu')) closeMegaMenuNow(menu);
      else openMegaMenuNow(menu);
    });

    menu.addEventListener('keydown', e => {
      var isOpen = menu.classList.contains('has-active-menu');

      if (e.key === 'Escape') {
        if (!isOpen) return;
        e.preventDefault();
        closeMegaMenuNow(menu);
        toggle.focus();
        return;
      }

      if (e.target !== link && e.target !== toggle) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMegaMenuNow(menu);
        var first = frame.querySelector('a[href], button, [tabindex]:not([tabindex="-1"])');
        if (first) first.focus();
      }
    });

    menu.addEventListener('focusout', e => {
      if (!menu.classList.contains('has-active-menu')) return;
      if (e.relatedTarget && !menu.contains(e.relatedTarget)) closeMegaMenuNow(menu);
    });
  });

  // Close mega menu on small desktop/tablet screens, when clicking outside a mega menu
  document.body.addEventListener('click', e => {
    var targetIsMegaMenu = e.target.dataset.hasMegaMenu || e.target.closest('[data-has-mega-menu]');

    if (targetIsMegaMenu === activeMegaMenu) return;
    
    if (hasUsedTouch) {
      if (!targetIsMegaMenu && activeMegaMenu) {
        setMegaMenuOpen(activeMegaMenu, false);
        activeMegaMenu = false;
        preventMainLink = true;
      }
    }
  });
})(document, window);